import { connect } from "react-redux";
import styled, { css } from "styled-components";
import { useEffect, useState } from "react";
import { List as ListIcon, X } from "@phosphor-icons/react";
import { signOutAPI } from "../../store/actions";
import { Item } from "./Menu";

const { menuItems } = require('./MenuItems');

// Mobile account navigation: shows the current section and opens a sheet
// with every section. Replaces the old DOM class toggling.
const TopMenu = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  const items = menuItems(props);
  const current = items.find((item) => item.step === props.activeStep);

  useEffect(() => {
    document.body.classList.toggle("no-scroll", isOpen);
    return () => document.body.classList.remove("no-scroll");
  }, [isOpen]);

  const onItemClick = (menuItem) => {
    setIsOpen(false);
    menuItem.onClick();
  };

  return (
    <>
      <Toggle
        type="button"
        aria-expanded={isOpen}
        aria-label={isOpen ? "Close account menu" : "Open account menu"}
        onClick={() => setIsOpen((open) => !open)}
      >
        <span>{current ? current.name : "My Account"}</span>
        {isOpen ? <X size={20} /> : <ListIcon size={20} />}
      </Toggle>
      <Sheet $open={isOpen} aria-hidden={!isOpen}>
        <ul>
          {items.map((menuItem, i) => {
            const Icon = menuItem.icon;
            const isActive = menuItem.step && menuItem.step === props.activeStep;
            return (
              <li key={menuItem.name} style={{ "--i": i }}>
                <Item
                  type="button"
                  $active={isActive}
                  tabIndex={isOpen ? 0 : -1}
                  onClick={() => onItemClick(menuItem)}
                >
                  <Icon size={20} weight={isActive ? "fill" : "regular"} />
                  <span>{menuItem.name}</span>
                </Item>
              </li>
            );
          })}
        </ul>
      </Sheet>
    </>
  )
};

const Toggle = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  min-height: 40px;
  padding: 0 14px 0 16px;
  border-radius: var(--radius-pill);
  border: 1px solid rgb(254 254 254 / 0.3);
  background: rgb(254 254 254 / 0.08);
  color: #fefefe;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
`;

const Sheet = styled.div`
  position: fixed;
  inset: 64px 0 0 0;
  z-index: 150;
  padding: 16px;
  background: var(--navy);
  opacity: 0;
  visibility: hidden;
  transform: translateY(-8px);
  transition:
    opacity 0.3s var(--ease-out),
    transform 0.4s var(--ease-out),
    visibility 0s linear 0.4s;

  ul {
    list-style: none;
    margin: 0;
    padding: 0;
    display: grid;
    gap: 4px;
  }

  li {
    opacity: 0;
    transform: translateY(8px);
    transition:
      opacity 0.4s var(--ease-out),
      transform 0.4s var(--ease-out);
    transition-delay: calc(var(--i) * 35ms + 60ms);
  }

  ${({ $open }) =>
    $open &&
    css`
      opacity: 1;
      visibility: visible;
      transform: none;
      transition:
        opacity 0.3s var(--ease-out),
        transform 0.4s var(--ease-out),
        visibility 0s;

      li {
        opacity: 1;
        transform: none;
      }
    `}
`;

const mapStateToProps = (state) => {
  return {
    user: state.userState.user,
    profile: state.profileState.profile,
  };
};

const mapDipatchToProps = (dispatch) => ({
  signOut: () => dispatch(signOutAPI()),
});

export default connect(mapStateToProps, mapDipatchToProps)(TopMenu);
